import { appVersion } from '@/config/env'
import { useEffect, useState } from 'react'

const POLL_INTERVAL = 5 * 60 * 1000 // 5 minutes
const RELOAD_ATTEMPTED_KEY = 'version_reload_attempted'

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    const checkVersion = async (isInitialCheck: boolean) => {
      try {
        const res = await fetch(`/version.json?d=${new Date().getTime()}`, {
          cache: 'no-store',
        })
        if (!res.ok) return
        const { version } = (await res.json()) as { version: string }
        if (version !== appVersion) {
          if (isInitialCheck && !sessionStorage.getItem(RELOAD_ATTEMPTED_KEY)) {
            sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, '1')
            window.location.reload()
            return
          }
          setUpdateAvailable(true)
        }
      } catch {
        // network error — ignore
      }
    }

    checkVersion(true)
    const interval = setInterval(() => checkVersion(false), POLL_INTERVAL)
    return () => clearInterval(interval)
  }, [])

  return { updateAvailable }
}
